export default __webpack_public_path__ + "media/Microsoft365Admin.a519e735.svg";